import { isMentionType, type MentionType } from './mentionType';

// Shown when a host passes no translation for a mention whose member is gone.
export const MENTION_FALLBACK_LABEL = 'Former member';

interface MentionDisplayAttributes {
  type?: unknown;
  label?: unknown;
  inactive?: unknown;
}

// A mention shows as a chip only while what it names is still here and its kind is one this code knows.
export const isMentionAvailable = (
  attributes: MentionDisplayAttributes,
): attributes is MentionDisplayAttributes & { type: MentionType; label: string } =>
  isMentionType(attributes.type) &&
  typeof attributes.label === 'string' &&
  attributes.label !== '' &&
  !attributes.inactive;

export const mentionDisplayLabel = ({ label }: MentionDisplayAttributes, fallbackLabel: string): string =>
  (typeof label === 'string' && label) || fallbackLabel;
